import { CAMERA_TRACK_LIMITS, transitionWindow } from '../../domain/camera-keyframes';
import { PrecisionControl } from '../../components/PrecisionControl';
import { cameraFrameSeconds } from './camera-animation';
import type { CameraAnimation } from './use-camera-animation';

export function CameraOrientationTiming({ animation, duration }: { animation: CameraAnimation; duration: number }) {
  const seconds = cameraFrameSeconds(animation.seconds, duration);
  return <div className="orientation-timing" aria-label="Tilt and bank transition timing">
    {(['tilt', 'roll'] as const).map(axis => {
      const label = CAMERA_TRACK_LIMITS[axis].label, keys = animation.tracks?.[axis] ?? [];
      const key = keys.find(item => Math.abs(item.seconds - seconds) < .001);
      const previous = keys.filter(item => item.seconds < seconds).at(-1);
      const timed = key && animation.tracks?.version === 1 ? { ...key, transition: previous ? 'transition' as const : 'cut' as const,
        durationSeconds: 'interval' as const, easing: previous?.easing ?? key.easing } : key;
      const window = transitionWindow(timed ?? { seconds, easing: 'smooth', durationSeconds: 2 }, previous?.seconds ?? 0);
      const mode = timed?.transition === 'cut' ? 'cut' : timed?.durationSeconds === 'interval' ? 'interval' : 'transition';
      return <fieldset className="orientation-axis-timing" key={axis}>
        <legend>{label} transition</legend>
        <div className="orientation-timing-fields">
          <label>Mode<select aria-label={`${label} transition mode`} value={mode} onChange={event => animation.timing(axis, {
            transition: event.target.value === 'cut' ? 'cut' : 'transition',
            durationSeconds: event.target.value === 'interval' ? 'interval' : typeof key?.durationSeconds === 'number' ? key.durationSeconds : 2,
          })}><option value="transition">Transition</option><option value="cut">Cut</option><option value="interval">Entire interval</option></select></label>
          <label>Duration · s<PrecisionControl label={`${label} duration`} inputLabel={`${label} duration at playhead`}
            min={.1} max={30} step={.1} disabled={mode !== 'transition'} value={timed?.durationSeconds === 'interval' ? Math.max(.1, window.duration) : timed?.durationSeconds ?? 2}
            onChange={durationSeconds => animation.timing(axis, { durationSeconds })} /></label>
          <label>Easing<select aria-label={`${label} transition easing`} value={timed?.easing ?? 'smooth'} disabled={mode === 'cut'}
            onChange={event => animation.timing(axis, { easing: event.target.value as 'smooth' | 'linear' })}>
            <option value="smooth">Smooth</option><option value="linear">Linear</option></select></label>
        </div>
        <p>{seconds === 0 ? 'Film start · no incoming transition.' : mode === 'cut' ? `Cut at ${seconds.toFixed(2)}s.`
          : `Starts ${window.start.toFixed(2)}s · arrives ${seconds.toFixed(2)}s · ${window.duration.toFixed(2)}s effective.`}
          </p>
      </fieldset>;
    })}
  </div>;
}
